import { Typography } from '@mui/material';
import React from 'react';
import { H, V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import EllipsisText from '../../common/components/EllipsisText';

export default ({ item }) => {
    const { theme } = useStyling();

    return (
        <V gap={1.5} sx={{ overflow: 'hidden', p: 1 }}>
            <H fill>
                <EllipsisText text={item.name} />
            </H>
            <Typography color={theme.palette.text.secondary} variant="subtitle2">
                {item.location && typeof location === 'object' ? item.location.label : ''}
            </Typography>
            <Typography variant="subtitle2">{item.budgetCategory}</Typography>
            <EllipsisText text={item.about} clampLines={2} />
        </V>
    );
};
